import { Card, Row, Col, Table } from 'react-bootstrap';
import { useGetDivisionsQuery } from './divisions.api';
import Button from '../../components/base/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';

const ViewAllDivisions = () => {
  const navigate = useNavigate();
  const organizationId = localStorage.getItem('organizationId') || '';

  const {
    data: divisionsData,
    isLoading,
    isError
  } = useGetDivisionsQuery(organizationId, {
    skip: !organizationId
  });

  const handleCreateDivision = () => {
    navigate('/divisions/create');
  };

  return (
    <div>
      {/* <PageBreadcrumb items={defaultBreadcrumbItems} /> */}
      <div className="mb-9">
        <Row className="align-items-center justify-content-between g-3 mb-4">
          <Col md="auto">
            <h2 className="mb-0">All Divisions</h2>
          </Col>
          <Col md="auto">
            <Button variant="phoenix-primary" className="px-5" onClick={handleCreateDivision}>
              <FontAwesomeIcon icon={faPlus} className="me-2" />
              Create Division
            </Button>
          </Col>
        </Row>

        <Card>
          <Card.Body>
            {isLoading && (
              <div className="text-center py-5">
                <p className="text-muted">Loading divisions...</p>
              </div>
            )}

            {isError && (
              <div className="text-center py-5">
                <p className="text-danger">Failed to load divisions. Please try again.</p>
              </div>
            )}

            {!isLoading && !isError && divisionsData?.divisions && (
              <Table responsive hover>
                <thead>
                  <tr>
                    <th>Division Name</th>
                    <th>Organization</th>
                    <th>Created At</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {divisionsData.divisions.length > 0 ? (
                    divisionsData.divisions.map((division: any) => (
                      <tr key={division._id || division.divisionId}>
                        <td>{division.title}</td>
                        <td>{division.organization_id}</td>
                        <td>
                          {division.created_at?.$date
                            ? new Date(division.created_at.$date).toLocaleDateString()
                            : 'N/A'}
                        </td>
                        <td>
                          <Button variant="phoenix-secondary" size="sm">
                            View
                          </Button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={4} className="text-center py-4">
                        <p className="text-muted mb-0">
                          No divisions found. Create your first division to get started.
                        </p>
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            )}
          </Card.Body>
        </Card>
      </div>
    </div>
  );
};

export default ViewAllDivisions;
